module.exports = __webpack_public_path__ + "img/feather.76199d81.svg";